import styled, { css } from 'styled-components';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton/styledButton';
// @ts-ignore
import InputSimple from '@ertelecom/ui-react/components/inputSimple';
// @ts-ignore
import phoneDecorator from '@ertelecom/ui-react/components/inputSimple/decorators/phoneDecorator';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';

const breakpoints = {
    desktop: '1599px',
    sDesktop: '1359px',
    xsDesktop: '1279px',
    mobile: '600px'
};

const inputPhone = phoneDecorator(InputSimple);

interface IWrapperStyles {
    marginTop?: string,
    marginBottom?: string,
    fixedHeight?: boolean
    background?: string,
    backgroundColor?: string,
    customStyles?: Record <string, any>,
    adaptive?: boolean,
    backgroundMobile?: string,
}

interface IContentStyles {
    size?: string,
    customStyles?: Record <string, any>,
    extStyles?: Record <string, any>,
    adaptive?: boolean,
}

interface ITitleStyles {
    extStyles?: Record <string, any>,
    textColor?: string
}

interface IImageStyles {
    position?: string,
    marginRight?: string,
    adaptive?: boolean,

}

interface IFrontImageDesktopStyles {
    imageHeight?: string,
    adaptive?: boolean,
    hasMobileImage: boolean
}

interface IPhoneBlockStyles {
    extStyles?: Record <string, any>,
}

export const Wrapper = styled.div<IWrapperStyles>`
    margin-top: ${({ marginTop }) => marginTop ? marginTop : '40px'};
    margin-bottom: ${({ marginBottom }) => marginBottom ? marginBottom : '0'};
    width: 100%;
    height: ${p => p.fixedHeight ? '320px' : 'auto'};
    white-space: normal;
    position: relative;
    display: flex;
    flex-wrap: nowrap;  
    align-items: center;
    background-image: ${p => p.background ? `url(${p.background})` : 'none'};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 4px;
    overflow: hidden;
    background-color: ${p => p.backgroundColor ? p.backgroundColor : 'transparent'};
    ${p => p.customStyles?.default ? p.customStyles?.default : ''};
    
    @media(max-width: ${breakpoints.desktop}) {
      height: ${p => p.fixedHeight ? '248px' : 'auto'};
      ${p => p.customStyles?.desktop ? p.customStyles?.desktop : ''};
    }

    @media(max-width: ${breakpoints.sDesktop}) {
      ${p => p.customStyles?.sDesktop ? p.customStyles?.sDesktop : ''};
    }
    
    @media(max-width: ${breakpoints.mobile}) {
        flex-wrap: wrap;
        ${p => p.customStyles?.mobile ? p.customStyles?.mobile : ''};
    }
    
    ${p => p.adaptive && css`
    @media(max-width: ${breakpoints.mobile}) {
        flex-direction: column;
        background-image: ${(p: IWrapperStyles) => p.backgroundMobile ? `url(${p.backgroundMobile})` : (p.background ? `url(${p.background})` : 'none')}
    };
    `};
    @media(max-width: 420px) {
      justify-content: space-between;
    }
`;

export const Content = styled.div<IContentStyles>`
    display: block;
    position: relative;
    padding: 70px 0 70px 35px;
    ${p => p.size === 'small' && css`
        padding: 38px 0 38px 35px;
        & > ${Title} {
            font-size: 20px;
        }
    `};
    width: 753px;
    z-index: 3;
    white-space: normal;
    ${p => p.customStyles ? p.customStyles : ''};
    ${p => p.extStyles?.default ? p.extStyles?.default : ''};

    @media(max-width: ${breakpoints.desktop}) {
        padding: 60px 0 70px 35px;
        width: 600px;
        ${p => p.extStyles?.desktop ? p.extStyles?.desktop : ''};
    };
    @media(max-width: ${breakpoints.xsDesktop}) {
        padding-left: 30px;
        ${p => p.extStyles?.xsDesktop ? p.extStyles?.xsDesktop : ''};
    };
    @media(max-width: 1023px) {
        width: 490px;
        padding-left: 30px;
    };
    @media (max-width: 950px) {
        width: 450px;
    }
    @media (max-width: 768px) {
        padding-left: 30px;
        width: 420px;
    }
    @media (max-width: 700px) {
        width: 370px;
    }
    @media (max-width: ${breakpoints.mobile}) {
        height: 345px;
    }
    ${p => p.adaptive
        ? css`
            @media(max-width: ${breakpoints.mobile}) {
                width: 100%;
                padding: 35px 20px 30px;
            };
        `
        : css`
            @media(max-width: ${breakpoints.mobile}) {
                width: 60%;
                padding: 35px 20px 30px;
            };
        `
    };
`;

export const Title = styled.div<ITitleStyles>`
    display: block;
    font-family: ${FONTS.regular};
    margin-bottom: 16px;
    font-size: 32px;
    line-height: 1.33;
    color: ${({ textColor }) => textColor ? textColor : COLORS.black};
    ${p => p.extStyles ? p.extStyles : ''};

    span {
        display: inline-block;
    }
   @media(max-width: ${breakpoints.desktop}) {
        font-size: 24px;
        ${p => p.extStyles?.desktop ? p.extStyles?.desktop : ''};
    };
    @media(max-width: ${breakpoints.xsDesktop}) {
        font-size: 20px;
        margin-bottom: 15px;
    }
    @media(max-width: 768px) {
        margin-bottom: 10px;
    }
    @media(max-width: ${breakpoints.mobile}) {
        margin-bottom: 15px;
    }
`;

export const SubTitle = styled.div<{textColor?: string}>`
    display: block;
    font-family:  ${FONTS.light};
    margin-bottom: 12px;
    font-size: 16px;
    line-height: 1.33;
    color: ${({ textColor }) => textColor ? textColor : COLORS.black};
`;

export const Description = styled.div<{textColor?: string}>`
    display: block;
    font-family: ${FONTS.light};
    margin-bottom: 32px;
    font-size: 16px;
    line-height: 1.33;
    color: ${({ textColor }) => textColor ? textColor : COLORS.black};
    span {
        display: inline-block;
    }
    @media(max-width: 1599px) {
        margin-bottom: 30px;
    };
    @media(max-width: ${breakpoints.xsDesktop}) {
        font-size: 14px;
        margin-bottom: 25px;
    };
    @media(max-width: 768px) {
        margin-bottom: 20px;
    }
`;

export const ButtonBlock = styled.div`
    display: block;
`;

export const Images = styled.div<IImageStyles>`
    display: flex;
    height: 100%;
    width: calc(100% - 753px);
    position: relative;
    img {
        margin: ${p => p.position === 'bottom' ? 'auto auto 0 auto' : 'auto'};
        max-height: 100%;
        max-width: 100%;
        margin-right: ${p => p.marginRight ? p.marginRight : 'auto'};
    }
    @media(max-width: 1599px)  {
        width: calc(100% - 600px);
    }
    @media(max-width: ${breakpoints.xsDesktop})  {
        width: calc(100% - 500px);
    }
    @media(max-width: 1023px)  {
        width: calc(100% - 490px);
    }
    @media (max-width: 950px) {
        width: calc(100% - 450px);
    }
    @media (max-width: 700px) {
        width: calc(100% - 370px);
    }
    ${p => p.adaptive
        ? css`
            @media(max-width: ${breakpoints.mobile}) {
                flex-direction: column;
                width: 100%;
                height: auto;
                img {
                    position: relative;
                }
            };
        `
        : css`
            @media(max-width: ${breakpoints.mobile}) {
                width: 40%;
            };
        `
    }
`;

export const FrontImageDesktop = styled.img<IFrontImageDesktopStyles>`
    display: block;
    ${p => p.imageHeight ? `height: ${p.imageHeight}` : ''};
    ${p => p.adaptive && css`
        @media(max-width: ${breakpoints.mobile}) {
            display: ${(p: IFrontImageDesktopStyles) => p.hasMobileImage ? 'none' : 'block'};
        };
    `};
`;

export const FrontImageMobile = styled.img<{adaptive?: boolean}>`
    display: none;
    ${p => p.adaptive && css`
        @media(max-width: ${breakpoints.mobile}) {
            display: block;
        };
    `};
`;

export const TextButton = styled.a`
    cursor: pointer;
`;

export const Button = styled(StyledButton)`
    min-width: 211px;
    width: auto;
    @media(max-width: 1179px) {
        padding: 13px 20px;
        font-size: 14px;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
        overflow: hidden;
        min-width: 200px;
    }
    @media(max-width: 530px) {
        width: 100%;
        padding: 13px 9px;
    }
`;
export const InputPhone = styled(inputPhone)<IPhoneBlockStyles>`
    max-width: 255px;
    height: 40px;
    border-radius: 4px;
    padding: 0;
    input {
        background: rgba(255, 255, 255, 0.3);
        border: 1px solid rgba(26, 26, 26, 0.5);
        ${p => p.extStyles?.input ? p.extStyles.input : ''};

        &::placeholder {
            color: ${p => p.extStyles?.input ? p.extStyles?.input : ''};
        }
    }
    span {
        color: ${p => p.extStyles?.span ? p.extStyles?.span : ''}
    }
    p {
        position: absolute;
        top: 40px;
    }
    @media(max-width: ${breakpoints.mobile}) {
        width: 100%;
        max-width: unset;
    }
`;

export const PhoneBlock = styled.div`
    display: flex;
    width: 773px;
    @media(max-width: 635px) {
        width: 500px;
    }
    @media(max-width: ${breakpoints.mobile}) {
        width: 100%;
        justify-content: center;
    }
`;

export const ConnectButton = styled(StyledButton)`
    max-width: 143px;
    height: 40px;
    width: auto;
    text-align: center;
    margin-left: 20px;
    padding: 0;
    @media(max-width: ${breakpoints.mobile}) {
        margin-left: 0;
        max-width: unset;
        width: 100%;
    }
`;

export const DetailsLink = styled.a<IPhoneBlockStyles>`
    cursor: pointer;
    height: 15px;
    margin-left: 15px;
    margin-top: 12px;
    @media(max-width: 635px) {
        margin-left: 0;
        margin-top: 0;
        order: 1;
    }
    @media(max-width: ${breakpoints.mobile}) {
        margin-top: 12px;
    }
    ${p => p.extStyles?.detailsLink ? p.extStyles?.detailsLink : ''};
`;

export const FootNote = styled.div<IPhoneBlockStyles>`
    display: inline;
    ${p => p.extStyles?.offer ? p.extStyles?.offer : ''};
    font-size: 12px;
    opacity: 0.7;
    max-width: 300px;
    line-height: 1.25;
    display: flex;
    @media(max-width: ${breakpoints.mobile}) {
        margin-top: 8px;
        display: block;
        width: 100%;
        max-width: unset;
    }
`;

export const OfferLink = styled.a<IPhoneBlockStyles>`
    font-size: 12px;
    opacity: 0.7;
    text-decoration: underline;
    cursor: pointer;
    ${p => p.extStyles?.offer ? p.extStyles?.offer : ''};
`;

export const OfferLinkWrapper = styled.div`
    display: inline;
`;

export const Img = styled.img`
    border-radius:15px;
`;

export const PhoneBlockAutoWidth = styled(PhoneBlock)`
  width: auto;
   @media(max-width: 430px) {
      height: auto;
      justify-content: space-between;
  }
`;
